import React, { Component } from 'react';
import styled from 'styled-components/macro';
import Modal from 'react-modal';
import { connectModal } from 'redux-modal';
import { CONFIRM_DIALOG } from '../../../constants';
import { Button as ButtonV2 } from '../../../v2/components/button/Button';

class ConfirmDialog extends Component {
  constructor() {
    super();

    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleConfirm() {
    this.props.handleSubmit();
    this.props.handleHide();
  }

  handleCancel() {
    this.props.handleHide();
  }

  render() {
    const { show, handleHide, message, confirmLbl, cancelLbl } = this.props;

    return (
      <Modal
        isOpen={show}
        overlayClassName="dialog__overlay"
        className="dialog__content"
        onRequestClose={handleHide}
        role="dialog"
        ariaHideApp={true}
        contentLabel={message}
      >
        <div className="dialog--confirm">
          <div className="dialog__title">{message}</div>
          <ButtonContainer>
            <button
              className="dialog__btn dialog__btn--cancel"
              onClick={this.handleCancel}
            >
              {cancelLbl}
            </button>
            <ButtonV2
              onClick={this.handleConfirm}
              label={confirmLbl}
              size="small"
            />
          </ButtonContainer>
        </div>
      </Modal>
    );
  }
}

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 2em;
  align-items: center;
  justify-content: right;
  button {
    margin-right: 20px;
  }
`;

export default connectModal({ name: CONFIRM_DIALOG, destroyOnHide: true })(
  ConfirmDialog
);
